import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { IconArrowLeft } from "@tabler/icons-react"

interface Props {
  text: string
  onBack?: () => void
}

export function HeroBar({ text, onBack }: Props) {
  const { translate } = useTranslation()
  return (
    <div className="flex w-full items-center gap-3 border-b border-grey4 bg-grey1 px-6 py-3">
      {onBack && (
        <button
          onClick={onBack}
          className="shrink-0 text-grey5 transition-colors hover:text-white"
          aria-label={translate("QMS/COMMON/BACK_TO_OVERVIEW")}
        >
          <IconArrowLeft size={16} />
        </button>
      )}
      <p className="text-sm text-white">{text}</p>
    </div>
  )
}
